<template>
    <div class="menu" :class="{ 'menu--scrolled': scrolled }">
        <div class="container">
            <nav class="navbar navbar-expand-lg">
                <div class="container-fluid">
                    <a class="navbar-brand" href="#">
                        <span class="brand-name">Dra. Mônica Irma</span>
                    </a>
                    <button
                        class="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                        id="navbar-toggler"
                    >
                        <span class="toggler-line"></span>
                        <span class="toggler-line"></span>
                        <span class="toggler-line"></span>
                    </button>
                    <div
                        class="collapse navbar-collapse"
                        id="navbarSupportedContent"
                    >
                        <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a class="nav-link" href="#">Início</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#sobre">Sobre</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#facetas">Facetas</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#resultados">Resultados</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="#localizacao">Unidades</a>
                            </li>
                        </ul>
                        <div class="d-flex redes ms-lg-4">
                            <a
                                target="_blank"
                                href="https://www.instagram.com/dramonicairma/"
                                class="rede-link"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                            </a>
                            <a
                                target="_blank"
                                href="https://www.facebook.com/dramonicairma/"
                                class="rede-link"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                            </a>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            scrolled: false,
        };
    },
    mounted() {
        const fechar = document.getElementById("navbar-toggler");
        const elementos = document.getElementsByClassName("nav-link");

        for (var i = 0; i < elementos.length; ++i) {
            elementos[i].onclick = function () {
                if (window.innerWidth <= 991) {
                    fechar.click();
                }
            };
        }

        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods: {
        handleScroll() {
            this.scrolled = window.scrollY > 50;
        },
    },
};
</script>

<style src="./style.scss" lang="scss" scoped/>
